import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/784069abbb5d0e565eafdc580904c62f/5a64eb61aa29777aaae201bcdd9764aa.png" 
                alt="Mandado Express Logo" 
                className="h-12 w-auto"
              />
            </Link>
            
            <Link 
              to="/"
              className="bg-emerald-500 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-emerald-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Volver al Inicio
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-5xl font-bold text-gray-900 mb-4">Términos de Servicio</h1>
        <p className="text-gray-500 mb-12">Última actualización: Enero 2025</p>

        <div className="prose prose-lg max-w-none">
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">1. Aceptación de los Términos</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Al acceder y utilizar los servicios de Mandado Express, usted acepta estar sujeto a estos Términos de Servicio. 
              Si no está de acuerdo con alguna parte de estos términos, no debe utilizar nuestros servicios.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Mandado Express se reserva el derecho de modificar estos términos en cualquier momento. Los cambios entrarán 
              en vigor inmediatamente después de su publicación en nuestro sitio web.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">2. Descripción del Servicio</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Mandado Express es una plataforma que conecta usuarios con conductores independientes para servicios de:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li><strong>Transporte de pasajeros:</strong> Traslados urbanos e intermunicipales en Risaralda</li>
              <li><strong>Mensajería express:</strong> Envío rápido de documentos y paquetes pequeños</li>
              <li><strong>Encomiendas:</strong> Transporte de paquetes con seguimiento en tiempo real</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              Los conductores son contratistas independientes y no empleados de Mandado Express.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">3. Registro y Cuenta de Usuario</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Para utilizar ciertos servicios, puede ser necesario crear una cuenta. Usted se compromete a:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Proporcionar información precisa, actual y completa</li>
              <li>Mantener la seguridad de su contraseña</li>
              <li>Notificar inmediatamente cualquier uso no autorizado de su cuenta</li>
              <li>Ser responsable de todas las actividades realizadas bajo su cuenta</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">4. Tarifas y Pagos</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Las tarifas por nuestros servicios se calculan según la distancia, tipo de servicio y disponibilidad. 
              Los precios se informarán antes de confirmar cada servicio.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Los métodos de pago aceptados incluyen efectivo, transferencias bancarias y otros medios electrónicos 
              que se especifiquen en la plataforma.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Todas las tarifas son finales una vez completado el servicio, salvo errores evidentes o problemas 
              documentados durante la prestación del servicio.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">5. Cancelaciones y Reembolsos</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Cancelaciones por parte del usuario:</strong>
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Cancelaciones con más de 10 minutos de anticipación: sin cargo</li>
              <li>Cancelaciones con menos de 10 minutos: puede aplicar un cargo del 30%</li>
              <li>No presentarse al servicio: cargo del 100%</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              <strong>Cancelaciones por parte del conductor:</strong> Si un conductor cancela un servicio confirmado, 
              se le asignará otro conductor sin costo adicional.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">6. Responsabilidades del Usuario</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Los usuarios se comprometen a:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Tratar a los conductores con respeto y cortesía</li>
              <li>No transportar artículos ilegales, peligrosos o prohibidos</li>
              <li>Proporcionar información precisa sobre el origen y destino</li>
              <li>Estar disponible en el punto de recogida a la hora acordada</li>
              <li>No dañar los vehículos de los conductores</li>
              <li>Cumplir con todas las leyes y regulaciones aplicables</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">7. Responsabilidades de los Conductores</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Los conductores aliados se comprometen a:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Mantener sus vehículos en condiciones óptimas de funcionamiento</li>
              <li>Contar con todos los documentos legales vigentes (licencia, SOAT, revisión técnico-mecánica)</li>
              <li>Tratar a los usuarios con respeto y profesionalismo</li>
              <li>Seguir las rutas más eficientes</li>
              <li>Manejar con cuidado los paquetes y encomiendas</li>
              <li>Cumplir con los horarios acordados</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">8. Limitación de Responsabilidad</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Mandado Express actúa como intermediario entre usuarios y conductores independientes. No somos responsables de:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Daños o pérdidas de artículos personales durante el transporte</li>
              <li>Accidentes o incidentes durante la prestación del servicio</li>
              <li>Retrasos causados por condiciones de tráfico, clima u otras circunstancias fuera de nuestro control</li>
              <li>Comportamiento inapropiado de conductores o usuarios</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              Recomendamos contratar seguros adicionales para artículos de alto valor.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">9. Propiedad Intelectual</h2>
            <p className="text-gray-700 leading-relaxed">
              Todos los contenidos de la plataforma Mandado Express, incluyendo logotipos, diseños, textos, gráficos 
              y software, son propiedad de Mandado Express o sus licenciantes y están protegidos por las leyes de 
              propiedad intelectual de Colombia.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">10. Resolución de Disputas</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Cualquier disputa relacionada con estos términos o el uso de nuestros servicios se resolverá mediante:
            </p>
            <ol className="list-decimal pl-6 text-gray-700 space-y-2">
              <li>Negociación directa entre las partes</li>
              <li>Mediación a través de nuestro sistema de PQRS</li>
              <li>Arbitraje o jurisdicción de los tribunales de Pereira, Risaralda, Colombia</li>
            </ol>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">11. Terminación del Servicio</h2>
            <p className="text-gray-700 leading-relaxed">
              Mandado Express se reserva el derecho de suspender o terminar el acceso a nuestros servicios a cualquier 
              usuario que viole estos términos, sin previo aviso y sin responsabilidad alguna.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">12. Contacto</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Para preguntas sobre estos Términos de Servicio, puede contactarnos:
            </p>
            <ul className="list-none text-gray-700 space-y-2">
              <li><strong>Email:</strong> mandadoexpresscol@gmail.com</li>
              <li><strong>Teléfono:</strong> +57 316 492 4439</li>
              <li><strong>Dirección:</strong> Carrera 40 Calle 14 Esquina, Manzana 9 Casa 6, Pereira, Risaralda</li>
              <li><strong>WhatsApp:</strong> <a href="https://wa.me/message/2GTFXGJ74H5AD1" className="text-emerald-600 hover:text-emerald-700">Contactar por WhatsApp</a></li>
            </ul>
          </section>
        </div>

        <div className="mt-16 p-6 bg-emerald-50 rounded-2xl">
          <p className="text-gray-700 text-center">
            Al utilizar los servicios de Mandado Express, usted reconoce que ha leído, entendido y aceptado 
            estos Términos de Servicio en su totalidad.
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white rounded-t-[32px] mx-10 mt-24">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="text-center">
            <div className="text-gray-400 text-sm mb-4">
              © 2025 Mandado Express. Todos los derechos reservados.
            </div>
            <div className="flex justify-center space-x-6 text-sm">
              <Link to="/terms" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Términos de Servicio</Link>
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Privacidad</Link>
              <Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Inicio</Link>
            </div>
            <div className="mt-6">
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-500 hover:text-emerald-400 transition-colors text-sm cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
